import React from "react";
import { Group, Circle, Image } from "react-konva";
import { useImage } from "react-konva-utils";
import { ITaskController } from "../../controller";
import { TASK_WIDTH } from "shared/datamodel/task";
import useObservableController from "elements/hooks/use-observable-controller";
import { PADDING } from "../../consts";

const AVATAR_SIZE = 24;

/**
 * Displays assignee avatar on the task element. Render only when:
 * - An assignee has been changed on the task (Subscribed to "assignee-changed")
 */
export const TaskElementAssignee = React.memo(({ controller }: { controller: ITaskController }) => {
  useObservableController(controller, "assignee-changed");

  const assignee = controller.getAssignee();
  const [image, imageStatus] = useImage(assignee?.thumbnail || "");

  const { element } = controller;
  const { width = TASK_WIDTH } = element;
  const avatarX = width - AVATAR_SIZE - PADDING * 2;

  if (!assignee) return null;

  return (
    <Group x={avatarX}>
      <Circle x={AVATAR_SIZE / 2} y={AVATAR_SIZE / 2} radius={AVATAR_SIZE / 2} stroke="#DEE1EB" strokeWidth={1} />
      {image && imageStatus === "loaded" && (
        <Group
          clipFunc={(context: CanvasRenderingContext2D) => {
            const radius = AVATAR_SIZE / 2;
            context.beginPath();
            context.arc(AVATAR_SIZE / 2, AVATAR_SIZE / 2, radius, 0, Math.PI * 2, false);
            context.closePath();
          }}
        >
          <Image width={AVATAR_SIZE} height={AVATAR_SIZE} image={image} />
        </Group>
      )}
    </Group>
  );
});

TaskElementAssignee.displayName = "TaskElementAvatar";
